export default __webpack_public_path__ + "static/media/shield.0597db23.svg";